import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import { FlexLayout, Spinner } from "@/design-system/salt";

const ContentLoader = () => (
  <FlexLayout align="center" justify="center" style={{paddingTop: "96px", paddingBottom: "96px"}}>
    <Spinner aria-label="Loading page" size="medium" />
  </FlexLayout>
);

/** Dashboard Layout Route component. */
export default function DashboardLayoutRoute() {
  return (
    <DashboardLayout>
      <Suspense fallback={<ContentLoader />}>
        <Outlet />
      </Suspense>
    </DashboardLayout>
  );
}
